(function(){

if(window.innerWidth>749) return;

const modal=document.createElement("div");

modal.className="te-review-modal";

modal.innerHTML=`
<div class="te-review-modal-card">

    <button class="te-review-close">&times;</button>

    <img class="te-review-image" src="">

</div>
`;

document.body.appendChild(modal);

const image=modal.querySelector(".te-review-image");

document.addEventListener("click",function(e){

    if(window.innerWidth>749) return;

    const img=
        e.target.closest(".jm-media-grid__image") ||
        e.target.closest(".jm-media__image") ||
        e.target.closest(".jm-media-thumbnail-list__thumbnail img");

    if(!img) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    image.src=img.src
        .replace("width=160","width=1600")
        .replace("width=480","width=1600")
        .replace("width=1024","width=1600");

    modal.classList.add("active");

    return false;

},true);

modal.querySelector(".te-review-close").onclick=()=>{

    modal.classList.remove("active");

};

modal.onclick=(e)=>{

    if(e.target===modal){

        modal.classList.remove("active");

    }

};

})();